module.exports = __webpack_public_path__ + "img/bg_avatar_female_15.228de5ff.png";